// extracted by mini-css-extract-plugin
export default {"buttonFooter":"styles_buttonFooter__6-cit","studentName":"styles_studentName__WYTNA","createdAtText":"styles_createdAtText__WzR8h","divider":"styles_divider__af5LA"};